import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-auth-side-panel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './auth-side-panel.html',
  styleUrl: './auth-side-panel.css'
})
export class AuthSidePanel {}